
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Subscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Subscription"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailSubscription"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fieldPlaceholder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscribeCta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"terms"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"facebookLikeCta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"heading"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"separatorText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subheading"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":196}};
    doc.loc.source = {"body":"fragment Subscription on Subscription {\n  emailSubscription {\n    fieldLabel\n    fieldPlaceholder\n    subscribeCta\n    terms\n  }\n  facebookLikeCta\n  heading\n  separatorText\n  subheading\n  title\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
